import "preact/debug";
import Router from "preact-router";
import { route } from "preact-router";


import { h, Component, Fragment } from "preact";
import { useState, useContext, useRef, useEffect } from "preact/hooks";
/** @jsx h */

import { createTheme, ThemeProvider } from "@mui/material/styles";
import WithMainTheme from "./theme/WithMainTheme";
import WithMainTheme2 from "./theme/WithMainTheme2";
import WithMainThemeAnonymous from "./theme/WithMainThemeAnonymous";

import { CookiesProvider } from "react-cookie";
import HeaderAnonyme from "./components/HeaderAnonyme";
import { HeaderConnecte } from "./components/HeaderConnecte";
import Footer2 from "./components/Footer/footer2";
import FooterLight from "./components/Footer/footer_light";
import { SessionProvider, SessionContext } from "./SessionContext";
import { AppProvider } from "./AppContext";

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import frLocale from "date-fns/locale/fr";

import { BkPopups } from "./BkPopups";
import { BkSnack } from "./BkSnack";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";

class Redirect extends Component {
	componentWillMount() {
		//("componentWillMount redirect", this.props.to, this.props);
		route(this.props.to, true);
	}

	render() {
		console.log("return null");
		return null;
	}
}

const BKApp = (props) => {

	const [state, setState] = useState({ headerHeight: 69 })

	const componentRef = useRef(null);
	const componentRef2 = useRef(null);
	const componentRef3 = useRef(null);

	theme.overrides.MuiInputBase = {
		root: {
			color: "#FFFFFF",
			backgroundColor: "#000000",
		},
	};
	const RedirectBk = ({ to }) => {
		window.location.replace(to);
		return null;
	};
	//console.log("BKApp **", props);
	return (
		<CookiesProvider>
			<SessionProvider>
				<ThemeProvider theme={theme}>
					<AppProvider value={{ refSnack: componentRef, refPopUp: componentRef2, refHeader: componentRef3 }}>
						<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={frLocale}>
							<BkSnack ref={(node) => (componentRef.current = node)} />
							<BkPopups ref={(node) => (componentRef2.current = node)} />
							<CssBaseline />
							<SessionContext.Consumer>
								{session => {
									//console.log("SessionContext.Consumer", session);

									return (<Fragment>
										{session[0].conn ? <HeaderConnecte
											ref={(node) => (componentRef3.current = node)}
											setState={setState}
											to={props.to}
										/> : <HeaderAnonyme />}
										<div style={`margin-top: 100px; padding-left: 5px; padding-right: 5px; width: 100%; margin-top: ${(state.headerHeight + 5)}px; background-color: #f0f0f0; min-height: calc(100vh - 227px );`}>
											<Router>
												{/* <WithMainTheme2 path="/" cpt="home" /> */}
												<Redirect path="/" to="/dashboard" />
												<WithMainTheme path="/old" />
												<WithMainTheme path="/trouver-un-bien/:query/:advanced?" />
												<WithMainTheme2 path="/trouver-un-bien-a-paris-a8e41f" />

												<RedirectBk path="/cgu" to="https://www.bkeys.com/cgu" />
												<RedirectBk path="/cgv" to="https://www.bkeys.com/cgv" />
												<RedirectBk path="/mentions-legales" to="https://www.bkeys.com/mentions-legales" />
												{/* <WithMainTheme2 path="/cgv" />
												<WithMainTheme2 path="/cgu" /> */}
												<RedirectBk path="/contact" />
												{/* <WithMainTheme2 path="/mentions-legales" /> */}

												<WithMainTheme2 path="/devenir-ambassadeur/:step" />

												<WithMainTheme2 path="/devenir-vendeur/:step" />
												<WithMainTheme2 path="/devenir-acquereur/:step" />
												<WithMainTheme2 path="/inscription-vendeur" />

												<WithMainTheme2 path="/publicpage/:id" />

												{/* <WithMainTheme2 path="/search" /> */}
												<WithMainTheme2 path="/dashboard" />
												<WithMainTheme2 path="/dashboarda" />
												<WithMainTheme2 path="/dashboardv" />
												<WithMainTheme2 path="/dashboardp" />
												<WithMainTheme2 path="/dashboardn" />
												<WithMainTheme2 path="/dataroom/:id" />
												<WithMainTheme2 path="/unotifs" />
												<WithMainTheme2 path="/dnotifs" />

												<WithMainTheme2 path="/7bac6cb9d6ee4d70b1315393725f3a34/:id" />
												<WithMainTheme2 path="/11d1355181ac4376a09980601b420617/:id" />
												<WithMainTheme2 path="/1fdf58e512f54752959b369588380557/:id" />
												<WithMainTheme2 path="/508f2de0fa994052a6d0cbc0c3b4d8c7/:id" />
												<WithMainTheme2 path="/sellers/:id" />
												<WithMainTheme2 path="/buyers/:id" />
												<WithMainTheme2 path="/du/:id" />
												<WithMainTheme2 path="/dre/:id" />
												<WithMainTheme2 path="/dre0/:id/:step" />
												<WithMainTheme2 path="/newdealv/:id/:step" />
												<WithMainTheme2 path="/newdeala/:id/:step" />
												<WithMainTheme2 path="/e668ce390be04a6b88aa54d048a49b55" />
												<WithMainTheme2 path="/e668ce390be04a6b88aa54d048a49b55/:uid" />
												<WithMainTheme2 path="/mails" />
												<WithMainTheme2 path="/apt/:id" />
												<WithMainTheme2 path="/confirmphone/:id" />
												<WithMainTheme2 path="/user" />
												<WithMainTheme2 path="/support" />

												<WithMainTheme2 path="/setpwd" />
												<WithMainTheme2 path="/signdoc/:id" />
												<WithMainTheme2 path="/confirmed-email/:mode" />
												<WithMainTheme2 path="/make-public/:id" />
												<WithMainTheme2 path="/offers/:id" />
												<WithMainTheme2 path="/invite-notary-seller/:id" />
												<WithMainTheme2 path="/trouver-des-biens/:id?" />

												<WithMainThemeAnonymous path="/devenir-acquereur" />
												<WithMainThemeAnonymous path="/parrainage/:id" />
												<WithMainThemeAnonymous path="/devenir-vendeur" />
												<WithMainThemeAnonymous path="/devenir-ambassadeur" />
												<WithMainThemeAnonymous path="/inscription" />
												<WithMainThemeAnonymous path="/t/:id" />
												<WithMainThemeAnonymous path="/login" />
												<WithMainThemeAnonymous path="/lostpwd" />
												<WithMainThemeAnonymous path="/maintenance" />
												<WithMainThemeAnonymous path="/404" />
												<WithMainThemeAnonymous path="/search/:id?" />
												<WithMainThemeAnonymous path="/ambassadeurs" />
												<WithMainThemeAnonymous path="/nos_ambassadeurs" />
												<Redirect default to={`/404?r=${location.pathname}`} />
											</Router>
										</div>
										{session[0].conn ? <FooterLight /> : <Footer2 />}
									</Fragment>)
								}
								}
							</SessionContext.Consumer>
						</LocalizationProvider>
					</AppProvider>
				</ThemeProvider >
			</SessionProvider>
		</CookiesProvider >
	);
};

export default BKApp;
